"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "light";
const brand = "#8C0014";
const headerBackgroundColor = "#FFFFFF";
const headerTextColor = "#8C0014";
const mainInfoPortrait = brand;
const mainInfoLandscape = brand;
const fontFamily = `
@font-face{
    font-family: 'Source Sans Pro';
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    src: url('/fonts/source-sans-pro/EOT/SourceSansPro-Light.eot') format('embedded-opentype'),
         url('/fonts/source-sans-pro/WOFF2/TTF/SourceSansPro-Light.ttf.woff2') format('woff2'),
         url('/fonts/source-sans-pro/WOFF/OTF/SourceSansPro-Light.otf.woff') format('woff'),
         url('/fonts/source-sans-pro/OTF/SourceSansPro-Light.otf') format('opentype'),
         url('/fonts/source-sans-pro/TTF/SourceSansPro-Light.ttf') format('truetype');
}

@font-face{
    font-family: 'Source Sans Pro';
    font-weight: 300;
    font-style: italic;
    font-stretch: normal;
    src: url('/fonts/source-sans-pro/EOT/SourceSansPro-LightIt.eot') format('embedded-opentype'),
         url('/fonts/source-sans-pro/WOFF2/TTF/SourceSansPro-LightIt.ttf.woff2') format('woff2'),
         url('/fonts/source-sans-pro/WOFF/OTF/SourceSansPro-LightIt.otf.woff') format('woff'),
         url('/fonts/source-sans-pro/OTF/SourceSansPro-LightIt.otf') format('opentype'),
         url('/fonts/source-sans-pro/TTF/SourceSansPro-LightIt.ttf') format('truetype');
}

@font-face{
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  src: url('/fonts/source-sans-pro/EOT/SourceSansPro-Regular.eot') format('embedded-opentype'),
       url('/fonts/source-sans-pro/WOFF2/TTF/SourceSansPro-Regular.ttf.woff2') format('woff2'),
       url('/fonts/source-sans-pro/WOFF/OTF/SourceSansPro-Regular.otf.woff') format('woff'),
       url('/fonts/source-sans-pro/OTF/SourceSansPro-Regular.otf') format('opentype'),
       url('/fonts/source-sans-pro/TTF/SourceSansPro-Regular.ttf') format('truetype');
}

@font-face{
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: italic;
  font-stretch: normal;
  src: url('/fonts/source-sans-pro/EOT/SourceSansPro-It.eot') format('embedded-opentype'),
       url('/fonts/source-sans-pro/WOFF2/TTF/SourceSansPro-It.ttf.woff2') format('woff2'),
       url('/fonts/source-sans-pro/WOFF/OTF/SourceSansPro-It.otf.woff') format('woff'),
       url('/fonts/source-sans-pro/OTF/SourceSansPro-It.otf') format('opentype'),
       url('/fonts/source-sans-pro/TTF/SourceSansPro-It.ttf') format('truetype');
}

@font-face{
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  src: url('/fonts/source-sans-pro/EOT/SourceSansPro-Bold.eot') format('embedded-opentype'),
       url('/fonts/source-sans-pro/WOFF2/TTF/SourceSansPro-Bold.ttf.woff2') format('woff2'),
       url('/fonts/source-sans-pro/WOFF/OTF/SourceSansPro-Bold.otf.woff') format('woff'),
       url('/fonts/source-sans-pro/OTF/SourceSansPro-Bold.otf') format('opentype'),
       url('/fonts/source-sans-pro/TTF/SourceSansPro-Bold.ttf') format('truetype');
}

@font-face{
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: italic;
  font-stretch: normal;
  src: url('/fonts/source-sans-pro/EOT/SourceSansPro-BoldIt.eot') format('embedded-opentype'),
       url('/fonts/source-sans-pro/WOFF2/TTF/SourceSansPro-BoldIt.ttf.woff2') format('woff2'),
       url('/fonts/source-sans-pro/WOFF/OTF/SourceSansPro-BoldIt.otf.woff') format('woff'),
       url('/fonts/source-sans-pro/OTF/SourceSansPro-BoldIt.otf') format('opentype'),
       url('/fonts/source-sans-pro/TTF/SourceSansPro-BoldIt.ttf') format('truetype');
}
html {
    font-family: "Source Sans Pro", "Helvetica Neue", "Helvetica", sans-serif;
}
`;
exports.default = {
    brand,
    mainInfoPortrait,
    mainInfoLandscape,
    headerBackgroundColor,
    headerTextColor,
    style,
    fontFamily,
};
